/** HOP TYPES */
export const VALIDATION_TYPE_FLAT_RATE = 1;
export const VALIDATION_TYPE_HOP_ON_HOP_OFF = 2;
export const VALIDATION_TYPE_PENALTY = 3;

/** Transaction Types */

/** Transaction Recharge Types */
export const ON_BOARD_SALE_TYPE = 2;
export const ON_BOARD_SALE_CANCELLATION_TYPE = 3;
export const PRECHARGE_TYPE = 4;
export const CHARGE_TYPE = 5;
export const PREREFUND_TYPE = 6;
export const REFUND_TYPE = 7;
export const MEDIA_DEACTIVATION_TYPE = 10;

/** Transaction Journey Types */
export const VALIDATION_TYPE = 8;
export const TNE_VALIDATION_TYPE = 11;
export const PARTIAL_VALIDATION_TYPE = 12;

/** Transaction Product Types */
export const PRODUCT_VALIDATION_TYPE = 13;
export const PRODUCT_PRECHARGE_TYPE = 14;
export const PRODUCT_CHARGE_TYPE = 15;

export const VOIDED_ASSISTED_VALIDATION_TYPE = 18;
export const DELIMITER_TYPE = 990;

/** Media types */
export const TSC_MEDIA_TYPE = "1";
export const QR_ID_MEDIA_TYPE = "2";
export const QR_VB_MEDIA_TYPE = "3";
export const TNE_MEDIA_TYPE = "4";
export const QR_VOUCHER_MEDIA_TYPE = "5";
export const QR_TEMPORARY_PASS_MEDIA_TYPE = "6";
export const QR_TOURIST_PASS_MEDIA_TYPE = "7";
export const TSC_VOUCHER_MEDIA_TYPE = "8";
export const TSC_TEMPORARY_PASS_MEDIA_TYPE = "9";
export const TSC_TOURIST_PASS_MEDIA_TYPE = "10";

export const QR_TYPES = [
  QR_ID_MEDIA_TYPE,
  QR_VB_MEDIA_TYPE,
  QR_VOUCHER_MEDIA_TYPE,
  QR_TEMPORARY_PASS_MEDIA_TYPE,
  QR_TOURIST_PASS_MEDIA_TYPE
];

export const TOKEN_TYPES = [
  TSC_MEDIA_TYPE,
  TNE_MEDIA_TYPE,
  TSC_VOUCHER_MEDIA_TYPE,
  TSC_TEMPORARY_PASS_MEDIA_TYPE,
  TSC_TOURIST_PASS_MEDIA_TYPE
]

export const PRODUCT_TYPE = 13;
export const PROD_CODE = 3;